import * as z from "zod/v4";
import { RoutingRuleConfigSchema } from "./routing-rule-config";

/**
 * Per-integration configuration for Redo-managed returns with refulfillment,
 * applied only for merchants on managed returns. Only the rule-type pipeline
 * ({@link RoutingRuleConfigSchema}) is shared across providers.
 */
export const ShopifyManagedReturnsSchema = z.object({
  enabled: z.boolean().default(false),
  order: z
    .object({
      routingRules: z.array(RoutingRuleConfigSchema).nullish(),
      defaultFulfillmentLocation: z
        .object({
          externalLocationId: z.string().nullish(),
          teamId: z.string().nullish(),
        })
        .nullish(),
      allowSplitShipments: z.boolean().nullish(),
      fulfillmentTags: z.array(z.string()).nullish(),
    })
    .nullish(),
});

export type ShopifyManagedReturns = z.infer<typeof ShopifyManagedReturnsSchema>;
